import React from "react";
//#region redux
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AppState } from "store";
import { closeDialog } from "store/actions/utilActions";
//#endregion
//#region types
//#endregion
//#region components
import DialogContainer from "./dialogContainer";
//#endregion;

const DialogQueue: React.FC = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const { dialogQueue } = useSelector((store: AppState) => ({
    dialogQueue: store.util.dialogQueue,
  }));

  const onDialogClose = (id?: string) => {
    dispatch(closeDialog(id));
  };

  return (
    <>
      {dialogQueue.map((dialog, index) => (
        <DialogContainer key={dialog.id ?? index} {...dialog} closeDialog={onDialogClose.bind(null, dialog.id)} />
      ))}
    </>
  );
};

export default DialogQueue;
